var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "coupon-modal"
  }, [_c('popup', {
    ref: "popup",
    attrs: {
      "noActions": true,
      "scrolling": true
    }
  }, [_vm.coupon ? _c('coupon', _vm._g(_vm._b({
    attrs: {
      "coupon": _vm.coupon,
      "showCode": _vm.showCode,
      "showQrcodeButton": _vm.showQrcodeButton
    },
    on: {
      "confirmed": _vm.confirmed
    }
  }, 'coupon', _vm.$attrs, false), _vm.$listeners)) : _vm.redeemCodeBundleId ? _c('temp-coupon', _vm._g(_vm._b({
    attrs: {
      "redeem-code-bundle-id": _vm.redeemCodeBundleId
    },
    on: {
      "redeemed": _vm.redeemed
    }
  }, 'temp-coupon', _vm.$attrs, false), _vm.$listeners)) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }